import React from 'react';
import { Outlet } from 'react-router-dom';
import AddHeader from '../../../../../components/layout/header/add';
import useClientsDetailAddHeader from './hooks';

function ClientsDetailAddHeader() {
  const { clientId, clientById, currentTitle } = useClientsDetailAddHeader();

  return (
    <div>
      <AddHeader
        primary={{ route: '/clients', title: 'Clients' }}
        secondary={{ route: `/clients/${clientId}`, title: clientById?.name }}
        title={currentTitle}
      />
      <Outlet />
    </div>
  );
}

export default ClientsDetailAddHeader;
